


















import { Component, Vue } from 'vue-property-decorator';
import ReleaseNoteForm from '@/components/forms/ReleaseNoteForm.vue';

@Component({
    components: {
        ReleaseNoteForm
    }
})
export default class NotificationAdd extends Vue {
}
